export const isDailyFeedRecommendation = recommendation => (
  !recommendation?.kind || recommendation.kind === 'daily'
);

export const isRecommendationForStatusContext = (recommendation, statusContextId) => (
  Boolean(statusContextId)
  && Boolean(recommendation?.status_context_id)
  && String(recommendation.status_context_id) === String(statusContextId)
);
